import { AppConfigModel } from "../abstract/app-config.model";

export class OrganizationSize extends AppConfigModel {

    static override CLASS_NAME: string = 'OrganizationSize';
}
